const startWogaaTransaction = (
  trackingId: string,
  transactionName?: string,
) => {
  console.log('Transaction started:', { trackingId, transactionName });
  window.wogaaCustom?.startTransactionalService(trackingId);
};

const completeWogaaTransaction = (
  trackingId: string,
  transactionName?: string,
) => {
  console.log('Transaction completed:', { trackingId, transactionName });
  window.wogaaCustom?.addMeta({ agencyTxnId: trackingId });
  window.wogaaCustom?.completeTransactionalService(trackingId);
};

const activateSentiments = () => {
  const id = sessionStorage.getItem('wogaaSentimentUserId') as string;

  window.wogaaCustom?.addMeta({ agencyTxnId: id });
};

export { startWogaaTransaction, completeWogaaTransaction, activateSentiments };
